import React from 'react';
import Spinner from './ui/Spinner';

const LoadingStyle:React.CSSProperties = {
  height: '100vh',
  width: '100vw',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '18px',
};


function ApplicationLoading() {
  return (
    <div style={LoadingStyle}>
      <Spinner /> The application is loading
    </div>
  );
}

export default ApplicationLoading;
